import { PricingPlanResponse } from 'src/queries/organizations/pricingPlans/pricingPlans.types'
import { pricingPlansQueryKeys } from 'src/queries/queries.constants'
import { CustomQueryOptions, useExtendQuery } from 'src/queries/queries.utils'

export function useQueryPricingPlans(
  organizationId?: string,
  options?: CustomQueryOptions<PricingPlanResponse>,
) {
  return useExtendQuery({
    queryKey: pricingPlansQueryKeys.all(),
    queryUrl: () => `/saas/${organizationId}/plans`,
    ...options,
    enabled: !!organizationId && options?.enabled,
  })
}
